<template>
    <v-container>
        <v-divider></v-divider>
        <v-layout column class="mr-2 hidden-sm-and-up">
            <v-flex>
                <div class="mt-1 text-center">
                <v-btn
                text
                href="https://github.com/vuetifyjs/vuetify/releases/latest"
                target="_blank"
                disabled
                >
                    <span>Oberoende Granskning</span>
                </v-btn>
                </div>
                <div class="mt-1 text-center">
                    <v-btn
                    text
                    to="/about"
                    v-show="this.$route.path == '/' || this.$route.path =='/home'"
                    >
                    <span>Hur vi räknar</span>
                </v-btn>
                <v-btn
                    text
                    to="/"
                    v-show="this.$route.path == '/about'"
                >
                    <span class="m-2 hidden-sm-and-up">Till statistiken</span>
                </v-btn>
                </div>
            </v-flex>
        </v-layout>
        <v-layout column>
            <v-flex>
                <div class="mt-3 text-center">
                <v-btn
                text
                href="https://twitter.com/oscarschafer28"
                target="_blank"
                >
                <span class="mr-2">@oscarschäfer28</span>
            </v-btn>
            </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: "FootSection"
};
</script>
